import React from 'react'


export const catalogs = [
  {
    name: 'M',
    icon: (<span style={{ color: '#fce600', fontWeight: 'bold', fontSize: '18px', backgroundColor: '#007ED9', borderRadius: '4px', padding: '2px 5px' }}>M</span>),
    color: '#155dfc',
    colorContainer: '#84ccff',
    link: 'm',
    skus: 'MCH',
    condiciones: '¡Este es un presupuesto básico! Negociaremos con cada cliente individualmente.',
    condicionesImg: 'https://i.imgur.com/GZKkyBU.png',
  },
  {
    name: 'MV',
    icon: (<span style={{ color: '#ffffff', fontWeight: 'bold', fontSize: '18px', backgroundColor: '#fc8815', borderRadius: '4px', padding: '2px 5px' }}>MV</span>),
    color: '#fc8815',
    colorContainer: '#fcbe15',
    link: 'mv',
    skus: 'MV',
    condiciones: '¡Este es un presupuesto básico! Negociaremos con cada cliente individualmente.',
    condicionesImg: 'https://i.imgur.com/GZKkyBU.png',
  }
] 